// import AuthForm, { STATE_LOGIN } from 'components/AuthForm';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { Card, Col, Row } from 'reactstrap';
import { AuthContext } from 'src/authentication/AuthContext';
// import { login } from 'src/authentication/authService';
import { Button } from 'reactstrap';
import { msalInstance, loginRequest } from '../azure-ad/msal';
import { toast } from 'react-toastify';
import {
  useIsAuthenticated,
  UnauthenticatedTemplate,
  AuthenticatedTemplate,
} from '@azure/msal-react';
import { useAccessToken } from '../azure-ad';
import { loginAzureAd } from 'src/authentication/authService';
import PageSpinner from 'components/PageSpinner';
import promptPlusLogo from 'src/assets/images/new-promptplus-secondary-logo-default.png';
import { Link } from 'react-router-dom';

const LoginPage = (props) => {
  // const [formState, setFormState] = useState({ username: '', password: '' });
  const { setToken, admin } = useContext(AuthContext);
  const isAuthenticated = useIsAuthenticated();
  const accessToken = useAccessToken();
  const [adSigninSuccess, setAdSigninSuccess] = useState(true);
  const cmsLoginInProgress = useRef(false);

  const handleLoginAzureAd = async (token) => {
    if (cmsLoginInProgress.current) return;
    cmsLoginInProgress.current = true;

    await loginAzureAd({
      token,
    })
      .then((res) => {
        setToken(res.data.token);
        toast.success('Login with Azure AD sucessfully.');
        props.history.push('/');
      })
      .catch((error) => {
        console.error(error);
        alert('Please contact administrator!');
        setAdSigninSuccess(false);
        cmsLoginInProgress.current = false;
      });
  };

  useEffect(() => {
    if (isAuthenticated && accessToken && !admin) {
      handleLoginAzureAd(accessToken);
    }
    if (isAuthenticated && accessToken && admin) {
      props.history.push('/');
    }
  }, [admin, isAuthenticated, accessToken, props.history]);

  /*
  const handleAuthState = (authState) => {
    if (authState === STATE_LOGIN) {
      props.history.push('/login');
    } else {
      props.history.push('/signup');
    }
  };

  const handleLogoClick = () => {
    props.history.push('/');
  };

  const onChange = (key) => (event) => {
    setFormState((prevState) => ({
      ...prevState,
      [key]: event.target.value,
    }));
  };

  const onSubmit = (e) => {
    login(formState)
      .then((res) => {
        setToken(res.data.token);
        props.history.push('/');
      })
      .catch((error) => {
        console.error(error);
        alert(error.response?.data?.message || 'Something went wrong');
      });
    e.preventDefault();
  };
  */

  const handleLoginWithADClick = async () => {
    await msalInstance.loginRedirect(loginRequest);
  };

  const handleLogoutWithADClick = async () => {
    await msalInstance.logoutRedirect();
  };

  const renderAuthForm = () => (
    <Card body>
      {/* <AuthForm
        authState={props.authState}
        onChangeAuthState={handleAuthState}
        onLogoClick={handleLogoClick}
        usernameInputProps={{ onChange: onChange('username') }}
        passwordInputProps={{ onChange: onChange('password') }}
        onSubmit={onSubmit}
      /> */}
      <Logo />
      <h2
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 700,
        }}
      >
        CSM Integrating Azure AD Sign-In
      </h2>
      <hr />
      <UnauthenticatedTemplate>
        <Button size="lg" className="border-0" onClick={handleLoginWithADClick}>
          Login with Azure AD
        </Button>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <Button
          size="lg"
          className="border-0"
          onClick={handleLogoutWithADClick}
        >
          Logout with Azure AD
        </Button>
      </AuthenticatedTemplate>
    </Card>
  );

  return (
    <Row
      style={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Col md={6} lg={4}>
        <UnauthenticatedTemplate>{renderAuthForm()}</UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          {adSigninSuccess && <PageSpinner />}
          {!adSigninSuccess && renderAuthForm()}
        </AuthenticatedTemplate>
      </Col>
    </Row>
  );
};

function Logo() {
  return (
    <div className="text-center pb-4">
      <Link to="/">
        <img
          src={promptPlusLogo}
          className="rounded"
          style={{ width: 60, height: 60, cursor: 'pointer' }}
          alt="logo"
        />
      </Link>
    </div>
  );
}

export default LoginPage;
